module.exports = __webpack_public_path__ + "img/Lasagna Meal-Beef Bolognese_.beea9ecf.jpg";